/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* leveranciers.ts
* 9-3-2023 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Component} from '@angular/core';
import {Datatablescherm} from '../abstracts/datatablescherm.class';
import {Leverancier} from '../../models/leverancier';
import {DatatableDef} from 'sihw-ng/datatable/datatable.component';
import {Project} from '../../models/project';

@Component({
  selector: 'leverancierlijst',
  templateUrl: './leverancierlijst.html'
})
export class Leverancierlijstscherm extends Datatablescherm {
  _starttitle = 'Leveranciers';
  icon = 'fas fa-truck';
  model = Leverancier;

  tableQuery = Leverancier.recordquery([], []);

  //constructor ivm injection
  constructor() {
    super('debug');
  }

  async dataGetter(): Promise<Project[]> {
    return <Project[]> await super.dataGetter();
  }

  public readonly tableDefinition: DatatableDef = {
    standaardsortering: {
      key: 'naam',
      richting: 1
    },
    velden: {
      naam: {
        label: 'Naam'
      },
      leverancierstype: {
        label: 'Type',
        type: 'enum'
      }
    }
  };
}
